import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
// import axios from 'axios';
import { Map, fromJS } from 'immutable';
import reducers from './reducers';
import { createAxiosInstance } from './config/services';


// const axiosInstance = axios.create({
//   baseURL: '/api',
// });

const axiosInstance = createAxiosInstance('CLIENT');

const isBrowser = typeof window === 'object';

const initialState = fromJS(window.__INITIAL_STATE__) || Map({});

// Add devtools extension in dev mode for better development.
const composeEnhancers =
  isBrowser && process.env.NODE_ENV !== 'production' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__(initialState) : compose;

const enhancer = composeEnhancers(
  applyMiddleware(thunk.withExtraArgument(axiosInstance)),
);

const store = createStore(
  reducers,
  initialState,
  enhancer,
);

// replace reducers in store after change (HMR)
if (module.hot && process.env.NODE_ENV !== 'production') {
  module.hot.accept('./reducers', () => {
    const nextRootReducer = require('./reducers').default; // eslint-disable-line global-require
    store.replaceReducer(nextRootReducer);
  });
}

export default store;



// WEBPACK FOOTER //
// client/configureStore.js